"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Safely parse JSON string to object or null
 * @param parseString
 */

var safelyParseJson = function safelyParseJson(parseString) {
  try {
    return JSON.parse(parseString);
  } catch (e) {
    return null;
  }
};

exports.default = safelyParseJson;